module.exports = __webpack_public_path__ + "img/signature.46316f6d.png";